<app-menu-property (toggleFiltersEvent)="sidebarVisible = !sidebarVisible"></app-menu-property>

<div class="property-list-page">
    <div class="sidebar-backdrop" *ngIf="sidebarVisible" (click)="sidebarVisible = false"></div>

    <aside class="sidebar-filters" [class.open]="sidebarVisible">
        <app-filters
            [totalProperties]="(facade.total$ | async) ?? 0"
            [primaryFeatures]="(facade.primaryFeatures$ | async) ?? []"
            [secondaryFeatures]="(facade.secondaryFeatures$ | async) ?? []"
            [offers]="(facade.offers$ | async) ?? []"
            (filtersChanged)="facade.applyFilters($event)"
            (clear)="facade.clear()"></app-filters>
    </aside>

    <section class="property-results">
        <app-property-search-list
            [results]="facade.results$ | async"
            [loading]="facade.loading$ | async"
            [error]="facade.error$ | async"
            (retry)="facade.refresh()"></app-property-search-list>

        <p-paginator
            *ngIf="(facade.total$ | async) ?? 0"
            [rows]="(facade.page$ | async)?.pageSize ?? 10"
            [first]="(facade.page$ | async)?.offset ?? 0"
            [totalRecords]="(facade.total$ | async) ?? 0"
            [rowsPerPageOptions]="[10, 20, 50]"
            (onPageChange)="facade.changePage($event.first, $event.rows)"></p-paginator>
    </section>
</div>
